import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';

export type SecureChangeParams = { password: string } | { emailCode: string };

@Injectable({ providedIn: 'root' })
export class SecureChangeHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public fetchToken(
    secureChange: SecureChangeParams,
    skipCompany: boolean = false,
  ): Observable<{ secureChangeToken: string }> {
    return this.httpApi.post(`/secure_change/token`, null, { secureChange }, { skipCompany });
  }

  public requestEmailCode(): Observable<any> {
    return this.httpApi.post('/secure_change/email_code', null, null);
  }
}
